import { useTexts } from '../../../../../contexts/TextsContext';
import { resolveAssetUrl } from '../../../../../utils/utils';
import classes from './serviceCard.module.scss';

const ServiceCard = ({ service }) => {
    const texts = useTexts();

    return (
        <li className={classes.Card}>
            <img src={resolveAssetUrl(service.iconSrc)} alt="" aria-hidden="true" className={classes.Icon} />
            <h3 className={classes.Title}>{texts[`services.${service.id}.title`]}</h3>
            <p className={classes.Description}>{texts[`services.${service.id}.description`]}</p>
        </li>
    );
};

export default ServiceCard;
